import type { ZeytalFigma, ZeytalAssets } from "@zeytal/types";

const findNestedNodes = (
  nodes: ZeytalAssets.AbstractNestedNode[],
  parentFrame: ZeytalAssets.AbstractNestedNode | null = null,
) => {
  return nodes.reduce<ZeytalAssets.LeafNode[]>((acc, node) => {
    if (
      Object.prototype.hasOwnProperty.call(node, "exportSettings") &&
      !!node.exportSettings?.length
    ) {
      // Add the variant component name to its variants names
      // The comma is added to respect the variant child name syntax
      if (parentFrame) {
        node.name = parentFrame.name + ", " + node.name;
      }

      // Add elements w/ export settings
      acc.push(node as unknown as ZeytalAssets.LeafNode);
    } else if (
      node.type === "COMPONENT_SET" &&
      node.children &&
      node.children.length
    ) {
      // Search for variants and pass the parent
      acc.push(...findNestedNodes(node.children, node));
    } else if (node.children && node.children.length) {
      // Search for elements w/ children
      acc.push(...findNestedNodes(node.children));
    }
    return acc;
  }, []);
};

export const getNestedNodesByFileId = (
  figmaFiles: ZeytalFigma.MinimalFigmaFile[],
) => {
  return figmaFiles.reduce<ZeytalAssets.LeafNodesByFileId>((acc, file) => {
    const { fileId, document } = file;

    const nestedNodes = findNestedNodes(document.children);

    acc.push([fileId, nestedNodes]);

    return acc;
  }, []);
};
